module.exports = __webpack_public_path__ + "static/media/person-black.b83931a3.svg";